import { render, staticRenderFns } from "./vip_pay.vue?vue&type=template&id=5ff8dbb8&scoped=true&"
import script from "./vip_pay.vue?vue&type=script&lang=js&"
export * from "./vip_pay.vue?vue&type=script&lang=js&"
import style0 from "./vip_pay.vue?vue&type=style&index=0&id=5ff8dbb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff8dbb8",
  null
  
)

export default component.exports